<template>
  <router-view />  
</template>
